<template>
  <div class="pt-2">
    <v-card flat>
      <v-form v-model="valid">
        <v-row no-gutters align="center" justify="space-around">
          <v-col cols="12" sm="1" style="text-align: right">
            <label>事项编号:</label>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
              class="form-item-value"
              v-model="filter.id"
              label=""
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>事项名称：</label>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
              class="form-item-value"
              v-model="filter.name"
              label=""
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>状态：</label>
          </v-col>
          <v-col cols="12" sm="2">
            <v-select
              v-model="filter.status"
              :items="statusList"
              item-text="name"
              item-value="id"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" sm="1"></v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" class="mr-2" depressed @click="handleSearch"
              >查询</v-btn
            >
            <v-btn depressed @click="handleResetSearch">重置</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
        :headers="headers"
        fixed-header
        :items="desserts"
        class="elevation-1 mt-2"
        :loading="loading"
        :server-items-length="totalDesserts"
        :page.sync="filter.pageNum"
        :items-per-page.sync="filter.pageSize"
        @update:page="handlePageChanged"
        @update:items-per-page="handlePageSizeChanged"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" :disabled="!_hasButtonPermission('导入')" depressed class="mr-2" @click="doImport">
              导入
            </v-btn>
            <v-btn color="primary" :disabled="!_hasButtonPermission('导出')" depressed class="mr-2" @click="doExport">
              导出
            </v-btn>
          </v-toolbar>
        </template>
        <template
          v-slot:body="{ items }"
        >
          <tbody>
            <tr
              v-for="(item,index) in items"
              :key="item.id"
            >
              <td class="border-right-a">{{ item.id }}</td>
              <td 
                v-if="index==0||(index>0&&item.subjectName!=items[index-1].subjectName)" 
                :rowspan="_calcRowSpan(index,items,'subjectName')" 
                class="border-right-a">
                {{ item.subjectName }}
              </td>
              <td 
                v-if="index==0||(index>0&&item.typeName!=items[index-1].typeName)"
                :rowspan="_calcRowSpan(index,items,'typeName')" 
                class="border-right-a">{{ item.typeName }}</td>
              <td class="border-right-a">{{ item.editionCode }}</td>
              <td class="border-right-a">{{ item.name }}</td>
              <td class="border-right-a">{{ item.repairType===1?'自维':'外委' }}</td>
              <td class="border-right-a">{{ item.editionName }}</td>
              <td class="border-right-a">{{ item.budgetDesc }}</td>
              <td class="border-right-a">{{ item.priceSource }}</td>
              <td class="border-right-a">{{ item.times }}</td>
              <td class="border-right-a">{{ item.cycle }}</td>
              <td class="border-right-a">{{ item.status === 0 ? "禁用" : "启用" }}</td>
              <td class="border-right-a">{{ item.updateBy }}</td>
              <td class="border-right-a">{{ item.updateTime }}</td>
              <td>
                <v-btn
                  icon
                  class="mr-2"
                  :disabled="!_hasButtonPermission('编辑')" 
                  @click="editItem(item)"
                >
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  class="mr-2"
                  :disabled="item.status===1||!_hasButtonPermission('启用')"
                  @click="enableItem(item)"
                >
                  <v-icon> mdi-check-circle </v-icon>
                </v-btn>
                <v-btn
                  icon
                  class="mr-2"
                  :disabled="item.status===0||!_hasButtonPermission('禁用')"
                  @click="disableItem(item)"
                >
                  <v-icon> mdi-close-circle </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <!--导入弹窗-->
      <v-dialog v-model="importDialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
            >导入业务事项</v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-file-input
                    truncate-length="15"
                    label="选择excel"
                    small-chips
                    dense
                    v-model="importFile"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="handleImport"> 确认 </v-btn>
            <v-btn color="primary" text @click="downloadTemplate">
              下载模板
            </v-btn>
            <v-btn text @click="hideImport"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--编辑弹窗-->
      <v-dialog persistent v-model="editDialog" width="800">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
            >编辑业务事项</v-card-title
          >
          <v-card-text>
            <v-container>
              <v-form ref="formEdit" v-model="editValid">
                <v-row dense>
                  <!-- id无需获取值 -->
                  <v-col :cols="4">
                    <v-text-field
                      dense
                      outlined
                      readonly
                      :label="form.id.label"
                      v-model="formModel.id"
                      required
                    />
                  </v-col>
                  <v-col :cols="4">
                    <v-select
                      dense
                      outlined
                      :label="form.subjectId.label"
                      :placeholder="form.subjectId.placeholder"
                      v-model="formModel.subjectId"
                      :items="subjectList"
                      item-text="subjectName"
                      item-value="id"
                      required
                      :rules="form.subjectId.rules"
                      v-on:change="_bindSubjectChange"
                    />
                  </v-col>
                  <v-col :cols="4">
                    <v-select
                      dense
                      outlined
                      :label="form.typeId.label"
                      :placeholder="form.typeId.placeholder"
                      v-model="formModel.typeId"
                      :items="typeList"
                      item-text="typeName"
                      item-value="id"
                      required
                      :rules="form.typeId.rules"
                    />
                  </v-col>  
                </v-row>
                <v-row dense>
                  <v-col :cols="4">
                    <v-text-field
                      dense
                      outlined
                      :label="form.name.label"
                      :placeholder="form.name.placeholder"
                      v-model="formModel.name"
                      required
                      :rules="form.name.rules"
                    />
                  </v-col>
                  <v-col :cols="4">
                    <v-select
                      :label="form.repairType.label"
                      :placeholder="form.repairType.placeholder"
                      v-model="formModel.repairType"
                      :rules="form.repairType.rules"
                      :items="repairTypeList"
                      item-text="name"
                      item-value="id"
                      outlined
                      dense
                      required
                    ></v-select>
                  </v-col>
                  <v-col :cols="4">
                    <v-text-field
                      dense
                      outlined
                      :label="form.budgetDesc.label"
                      :placeholder="form.budgetDesc.placeholder"
                      v-model="formModel.budgetDesc"
                      required
                      :rules="form.budgetDesc.rules"
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col :cols="4">
                    <v-select
                      dense
                      outlined
                      :label="form.editionId.label"
                      :placeholder="form.editionId.placeholder"
                      v-model="formModel.editionId"
                      :items="editionList"
                      item-text="editionName"
                      item-value="id"
                      required
                      :rules="form.editionId.rules"
                    />
                  </v-col>
                  <v-col :cols="4">
                    <v-text-field
                      dense
                      outlined
                      :label="form.times.label"
                      :placeholder="form.times.placeholder"
                      v-model="formModel.times"
                      required
                      :rules="form.times.rules"
                      v-on:change="_bindPickNumInput('times')"
                    />
                  </v-col>
                  <v-col :cols="4">
                    <v-text-field
                      dense
                      outlined
                      :label="form.cycle.label"
                      :placeholder="form.cycle.placeholder"
                      v-model="formModel.cycle"
                      required
                      :rules="form.cycle.rules"
                      v-on:change="_bindPickNumInput('cycle')"
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col :cols="4">
                    <v-radio-group
                      v-model="formModel.status"
                      row
                    >
                      <v-radio
                        label="禁用"
                        value="0"
                      ></v-radio>
                      <v-radio
                        label="启用"
                        value="1"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="handleEdit"> 保存 </v-btn>
            <v-btn text @click="hideEdit"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>
<script>
import { default as BudgetMatterApi } from "@/api/pd/budget/BudgetMatterApi.js";
import {default as PermissionApi} from "@/api/smp/auth/Permission.js";
import downloadUtil from "@/util/downloadUtil.js";
export default {
  name: "Pd-Manager-Budget-Matter",
  props: {
    buttonPriviledgeList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      statusList: [
        { id: 0, name: "禁用" },
        { id: 1, name: "启用" }
      ],
      repairTypeList: [
        { id: 1, name: "自维" },
        { id: 2, name: "外委" }
      ],
      filter: {
        id: "",
        name: "",
        status: null,
        pageNum: 1,
        pageSize: 15,
      },
      headers: [
        {
          text: "事项编号",
          value: "id",
          sortable: false,
          width: 90,
          divider: true,
        },
        {
          text: "所属科目",
          value: "subjectName",
          sortable: false,
          width: 100,
          divider: true,
        },
        {
          text: "事项类别",
          sortable: false,
          value: "typeName",
          width: 120,
          divider: true,
        },
        {
          text: "校对序号",
          sortable: false,
          value: "editionCode",
          width: 90,
          divider: true,
        },
        {
          text: "业务事项",
          sortable: false,
          value: "name",
          width: 150,
          divider: true,
        },
        {
          text: "自维/外委",
          align: "start",
          sortable: false,
          value: "repairType",
          width: 100,
          divider: true,
        },
        {
          text: "系统版本映射",
          align: "start",
          sortable: false,
          value: "editionName",
          width: 150,
          divider: true,
        },
        {
          text: "预算费用组成",
          align: "start",
          sortable: false,
          value: "budgetDesc",
          width: 150,
          divider: true,
        },
        {
          text: "单价来源",
          align: "start",
          sortable: false,
          value: "priceSource",
          width: 150,
          divider: true,
        },
        {
          text: "标准次数",
          align: "start",
          sortable: false,
          value: "times",
          width: 90,
          divider: true,
        },
        {
          text: "周期",
          align: "start",
          sortable: false,
          value: "cycle",
          width: 80,
          divider: true,
        },
        {
          text: "状态",
          align: "start",
          sortable: false,
          value: "status",
          width: 80,
          divider: true,
        },
        {
          text: "修改人",
          align: "start",
          sortable: false,
          value: "updateBy",
          width: 80,
          divider: true,
        },
        {
          text: "最后修改时间",
          align: "start",
          sortable: false,
          value: "updateTime",
          width: 150,
          divider: true,
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
          width: 170,
          divider: true,
        },
      ],
      desserts: [],
      loading: false,
      totalDesserts: 0,
      valid: false,
      importDialog: false,
      btnDisabled: false,
      importFile: undefined,
      matterId: null,
      editDialog: false,
      editValid: false,
      formModel: {
        id: null,
        subjectId: null,
        typeId: null,
        editionId: null,
        name: null,
        repairType: null,
        budgetDesc: null,
        priceSource: null,
        times: null,
        cycle: null,
        status: null
      },
      form: {
        id: {
          label: '业务编号',
        },
        subjectId: {
          label: '科目',
          placeholder: '请选择所属科目',
          rules: [(v) => !!v || '必填']
        },
        typeId: {
          label: '事项类别',
          placeholder: '请选择事项类别',
          rules: [(v) => !!v || '必填']
        },
        editionId: {
          label: '预算版本',
          placeholder: '请选择预算版本',
          rules: [(v) => !!v || '必填']
        },
        name: {
          label: '业务事项',
          placeholder: '请输入业务事项',
          rules: [(v) => !!v || '必填']
        },
        repairType: {
          label: '自维/外委',
          placeholder: '请选择维护类型',
          rules: [(v) => !!v || '必填']
        },
        budgetDesc: {
          label: '预算费用组成',
          placeholder: '请输入预算费用组成',
          rules: [(v) => !!v || '必填']
        },
        priceSource: {
          label: '单价来源',
          placeholder: '请输入单价来源',
          rules: [(v) => !!v || '必填']
        },
        times: {
          label: '标准次数',
          placeholder: '请输入标准次数',
          rules: [(v) => !!v || '必填']
        },
        cycle: {
          label: '周期（年）',
          placeholder: '请输入周期',
          rules: [(v) => !!v || '必填']
        }
      },
      subjectList: [],
      typeList: [],
      editionList: [],
    };
  },
  mounted() {
    this.getButtonPriviledge();
    this.getDataFromApi();
  },
  methods: {
    getButtonPriviledge(){
      console.log('this.page',this.page)
      let menuId = this.page.id
      let me = this
      PermissionApi.queryButtonPriviledge(menuId,null).then(resp=>{
        PermissionApi.handleResponse(resp, me, function (data){
          me.buttonPriviledgeList = data.buttonPriviledges
          console.log('buttonPriviledgeList',me.buttonPriviledgeList)
        })
      })
    },
    handleSearch() {
      this.getDataFromApi();
    },
    handleResetSearch() {
      this.filter = {
        id: "",
        name: "",
        status: null,
        pageNum: 1,
        pageSize: 15,
      };
      this.getDataFromApi();
    },
    handlePageChanged(pageNum) {
      this.filter.pageNum = pageNum;
      this.getDataFromApi();
    },
    handlePageSizeChanged(pageSize) {
      if (pageSize == -1) {
        pageSize = 100;
      }
      this.filter.pageNum = 1;
      this.filter.pageSize = pageSize;
      this.getDataFromApi();
    },
    async getDataFromApi() {
      let me = this;
      me.loading = true;
      let queryUserResp = await BudgetMatterApi.list(me.filter);
      console.log("load user returned;");
      console.log(queryUserResp);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取业务事项失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      if (!data.data || !data.data.rows) {
        me.loading = false;
        throw new Error("获取事项类别情况失败(无会话数据)");
      }
      me.loading = false;
      me.desserts = data.data.rows;
      me.totalDesserts = data.data.total;
    },
    async exportData() {
      let me = this;
      let res = await BudgetMatterApi.exportData(me.filter);
      downloadUtil.downloadByBlob({ res: res.data, fileName: "业务事项导出结果.xlsx" });
    },
    doImport() {
      this.importDialog = true;
    },
    hideImport() {
      this.importDialog = false;
    },
    async handleImport() {
      let me = this;
      let file = me.importFile;
      if (!file || !file.size) {
        me.$dialog.error({
          text: "文件必传",
          title: "操作失败",
        });
        return;
      }
      let res = await BudgetMatterApi.importData(file);
      console.log("导入结果", res);
      if (res.data.code === 200) {
        me.$dialog.info({
          text: res.data.msg,
          title: "操作成功",
        });
        me.getDataFromApi();
      } else {
        me.$dialog.error({
          text: res.data.msg_detail,
          title: res.data.msg,
        });
      }
      me.hideImport();
      me.importFile = undefined;
    },
    async downloadTemplate() {
      let me = this;
      let res = await BudgetMatterApi.importTemplate();
      downloadUtil.downloadByBlob({ res: res.data, fileName: "业务事项导入模板.xlsx" });
    },
    doExport() {
      let me = this;
      me.exportData();
    },
    async disableItem(item) {
      let me = this;
      let confirm = await me.$dialog.confirm({
        text: "确认停用业务事项吗？",
        title: "提示",
      });
      if (confirm) {
        let res = await BudgetMatterApi.disable(item.id);
        if (res.data.code === 200) {
          me.$dialog.info({
            text: res.data.msg,
            title: "操作成功",
          });
          me.getDataFromApi();
        } else {
          me.$dialog.error({
            text: res.data.msg,
            title: "操作失败",
          });
        }
      }
    },
    async enableItem(item) {
      let me = this;
      let confirm = await me.$dialog.confirm({
        text: "确认启用业务事项吗？",
        title: "提示",
      });
      if (confirm) {
        let res = await BudgetMatterApi.enable(item.id);
        if (res.data.code === 200) {
          me.$dialog.info({
            text: res.data.msg,
            title: "操作成功",
          });
          me.getDataFromApi();
        } else {
          me.$dialog.error({
            text: res.data.msg,
            title: "操作失败",
          });
        }
      }
    },
    editItem(item) {
      this.matterId = item.id
      this.editDialog = true
      this.formModel = {
        id: item.id,
        subjectId: ''+item.subjectId,
        typeId: ''+item.typeId,
        editionId: ''+item.editionId,
        name: item.name,
        repairType: item.repairType,
        budgetDesc: item.budgetDesc,
        priceSource: item.priceSource,
        times: item.times,
        cycle: item.cycle,
        status: ''+item.status
      }
      this.querySubjectList()
      this.queryTypeList(item.subjectId)
      this.queryEditionList(item.subjectId)
    },
    async handleEdit(){
      if(!this.editValid){
        this.$dialog.error({
          title:'错误',
          text:'请完善信息'
        })
        return
      }
      let me = this;
      let res = await BudgetMatterApi.edit(me.formModel);
      if (res.data.code === 200) {
        me.$dialog.info({
          text: res.data.msg,
          title: "操作成功",
        });
        me.hideEdit()
        me.getDataFromApi();
      } else {
        me.$dialog.error({
          text: res.data.msg,
          title: "操作失败",
        });
      }
    },
    hideEdit(){
      this.matterId = null
      this.editDialog = false
      this.subjectList = []
      this.typeList = []
      this.editionList = []
    },
    async querySubjectList(){
      let me = this;
      let queryUserResp = await BudgetMatterApi.listSubject();
      console.log(queryUserResp)
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取科目列表失败" : msg;
        throw new Error(msg);
      }
      if (!data.data) {
        me.loading = false;
        throw new Error("获取科目列表情况失败(无会话数据)");
      }
      me.subjectList = data.data;
    },
    async queryTypeList(subjectId){
      let me = this;
      let queryUserResp = await BudgetMatterApi.listBudgetType({subjectId:subjectId});
      console.log(queryUserResp)
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取预算类别列表失败" : msg;
        throw new Error(msg);
      }
      if (!data.data) {
        me.loading = false;
        throw new Error("获取预算类别列表情况失败(无会话数据)");
      }
      me.typeList = data.data;
    },
    async queryEditionList(subjectId){
      let me = this;
      let queryUserResp = await BudgetMatterApi.listEdition({subjectId:subjectId});
      console.log(queryUserResp)
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取版本列表失败" : msg;
        throw new Error(msg);
      }
      if (!data.data) {
        me.loading = false;
        throw new Error("获取预算版本列表情况失败(无会话数据)");
      }
      me.editionList = data.data;
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList;
      let hasButton = false;
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == "Y") {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },
    _bindSubjectChange(){
      this.formModel.typeId = null
      this.formModel.editionId = null
      this.queryTypeList(this.formModel.subjectId)
      this.queryEditionList(this.formModel.subjectId)
    },
    _bindPickNumInput(title){
      let value = this.formModel[title].replace(/[^\d.]/g,'') || 0
      value = Number(value)
      if(value<0){
        value = 0
      }
      this.formModel[title] = value
    },
    _calcRowSpan(index,items,title){
      let name = items[index][title]
      let num = 0
      for(let i=index;i<items.length;i++){
        if(name!==items[i][title]){
          break
        }
        num++
      }
      return num
    }
  },
};
</script>
<style scoped>
.border-right-a{
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
</style>